var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"standalone-quoter"},[_c('h1',[_vm._v(_vm._s(_vm.$t('Cotizar unidad')))]),(_vm.unitObject)?_c('AppQuoteWizard',{attrs:{"unit":_vm.unitObject}}):_c('p',{staticClass:"error"},[_vm._v(" "+_vm._s(_vm.$t('La unidad seleccionada no puede ser cotizada.'))+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }